import './form-control.css';
export default {
  "formControl": "pf-v6-c-form-control",
  "formControlIcon": "pf-v6-c-form-control__icon",
  "formControlToggleIcon": "pf-v6-c-form-control__toggle-icon",
  "formControlUtilities": "pf-v6-c-form-control__utilities",
  "modifiers": {
    "textarea": "pf-m-textarea",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "error": "pf-m-error",
    "readonly": "pf-m-readonly",
    "plain": "pf-m-plain",
    "expanded": "pf-m-expanded",
    "disabled": "pf-m-disabled",
    "status": "pf-m-status",
    "icon": "pf-m-icon",
    "placeholder": "pf-m-placeholder",
    "resizeVertical": "pf-m-resize-vertical",
    "resizeHorizontal": "pf-m-resize-horizontal",
    "resizeBoth": "pf-m-resize-both"
  }
};